import { Component } from '@angular/core';

@Component({
  selector: 'app-reminder-sp',
  imports: [],
  templateUrl: './reminder-sp.html',
  styleUrl: './reminder-sp.css',

})
export class SpanishReminder {}
